import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { ButtonWithIcon, Text } from 'common-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const UploadAreaContainer = styled.div<{ $isDragActive?: boolean }>`
  padding: 20px;
  text-align: center;
  border-radius: 4px;
  border: 1px ${props => (props.$isDragActive ? 'solid' : 'dashed')};
  border-color: ${COLORS.secondarySemiLight};
  height: 136px;
  box-sizing: border-box;

  background-color: ${COLORS.primaryExtraLight};
  transition: all 0.2s ease;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: ${COLORS.primaryDark};
    background-color: ${COLORS.primaryExtraLight};
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    min-height: 96px;
  }
`

export const MobileUploadAreaContainer = styled.div`
  padding: 32px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.primaryExtraLight};
`

export const UploadContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const DragActiveContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const TextWithLines = styled(Text)`
  display: flex;
  align-items: center;
  width: 100%;
  text-align: center;
  line-height: 15px;

  &:before,
  &:after {
    content: '';
    flex: 1;
    height: 2px;
    margin: 0 16px;
  }

  &:before {
    background: linear-gradient(90deg, rgba(221, 227, 240, 0) 0%, #dde3f0 100%);
  }

  &:after {
    background: linear-gradient(90deg, #dde3f0 0%, rgba(221, 227, 240, 0) 100%);
  }
`

export const ButtonsRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 16px;
`

export const Button = styled(ButtonWithIcon)`
  justify-content: center;
  height: auto;
  width: auto;
  padding: 7px 16px;
  gap: 8px;
`

export const DragAndDropAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
